/* tslint:disable */
/* eslint-disable */
/**
 * deliveryProviderPortal delivery-campaign-provider api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const PromotionSectionKeys = {
        TYPE_OF_DISCOUNT: 'type_of_discount',
        DISCOUNT_VALUE_PERCENTAGE: 'discount_value_percentage',
        DISCOUNT_TARGETING: 'discount_targeting',
        MINIMUM_ORDER_VALUE: 'minimum_order_value',
        MAXIMUM_DISCOUNT_VALUE: 'maximum_discount_value',
        DOUBLE_DEAL_VALUE: 'double_deal_value'
} as const;
export type PromotionSectionKeys = typeof PromotionSectionKeys[keyof typeof PromotionSectionKeys];

